<template>
  <el-dialog
    v-if="visible"
    show-close
    :visible="visible"
    width="850px"
    :title="title"
    :close-on-click-modal="false"
    :before-close="() => close()"
    :modal-append-to-body="false"
    :modal="false"
    v-el-dialog-drag
  >
    <div>
      <div class="images-container">
        <el-upload
          multiple
          ref="uploader"
          action="#"
          :file-list="listImageFile"
          :limit="uploadFileMaxLimit"
          :on-exceed="onFileExceed"
          list-type="picture-card"
          :auto-upload="false"
          :on-change="uploadChange"
          accept=".jpeg,.jpg,.png,.gif"
        >
          <i slot="default" class="el-icon-plus"></i>
          <div slot="file" slot-scope="{ file }">
            <img
              class="el-upload-list__item-thumbnail"
              :src="file.url"
              alt=""
            />
            <span class="el-upload-list__item-actions">
              <span
                class="el-upload-list__item-preview"
                @click="onImagePreview(file)"
              >
                <i class="el-icon-zoom-in"></i>
              </span>
              <span
                class="el-upload-list__item-delete"
                @click="onImageRemove(file)"
              >
                <i class="el-icon-delete"></i>
              </span>
            </span>
          </div>
        </el-upload>
      </div>
      <div v-show="false" class="imagesViewer" v-viewer="{ movable: true }">
        <img
          v-for="item in listImageUrl"
          :src="item || '/image/static/img/nopic.jpg'"
          :key="item"
        />
      </div>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="close()">{{
        $l('INDEX.btn_cancel') || '取消'
      }}</el-button>
      <el-button size="small" type="primary" @click="uploadFabric()">{{
        $l('INDEX.btn_save') || '保存'
      }}</el-button>
    </span>
  </el-dialog>
</template>
<script>
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  props: {
    resFabricScmCode: { type: String, default: '' },
    resFabricRecordCode: { type: String, default: '' },
    visible: { type: Boolean, default: false },
    title: {
      type: String,
      default: '上传面料图片',
    },
  },
  data() {
    return {
      listImageFile: [],
      uploadFileMaxLimit: 10,
    }
  },
  computed: {
    isEmpty() {
      return !this.listImageFile || !this.listImageFile.length
    },
    listImageUrl() {
      return this.isEmpty ? [] : this.listImageFile.map((item) => item.url)
    },
  },

  methods: {
    onFileExceed(files, fileList) {
      this.$message.warning(
        (this.$l('INDEX.tips_limit_selection') || '限制选择') +
          `  ${this.uploadFileMaxLimit}  ` +
          (this.$l('INDEX.tips_file') || '文件') +
          ',' +
          (this.$l('INDEX.tips_selected_this_time') || '本次选择了') +
          `  ${files.length}  ` +
          (this.$l('INDEX.tips_file') || '文件') +
          ',' +
          (this.$l('INDEX.tips_a_total_of') || '共选择了') +
          `  ${files.length + fileList.length}  ` +
          this.$l('INDEX.tips_file') || '文件'
      )
    },
    async uploadChange(file, fileList) {
      this.listImageFile = fileList
    },
    onImagePreview(file) {
      if (this.isEmpty) return
      const fileIndex = this.listImageFile.findIndex(
        (item) => item.uid === file.uid
      )
      const viewer = this.$el.querySelector('.imagesViewer').$viewer
      viewer.view(fileIndex)
      viewer.show()
    },
    close() {
      this.$emit('update:visible', false)
    },
    onImageRemove(file) {
      this.$refs.uploader.handleRemove(file)
      const fileIndex = this.listImageFile.findIndex(
        (item) => item.uid === file.uid
      )
      this.listImageFile.splice(fileIndex, 1)
    },
    // async uploadFabric() {
    //   if (!this.listImage || !this.listImage.length) {
    //     this.$message.warning('请选择您需要上传的图片！')
    //     return
    //   }
    //   this.loadingOpen()
    //   const params = {
    //     resFabricScmCode: this.resFabricScmCode,
    //     resFabricRecordCode: this.resFabricRecordCode,
    //     fabricImageList: this.listImage,
    //   }
    //   const res = await this.$api
    //     .resFabricInfoPcPushImgApi(params)
    //     .catch(() => null)
    //   this.loadingClose()
    //   const { status } = res
    //   if (status !== 200) {
    //     this.$message.error(
    //       this.$l('INDEX.uploader_label_status_error') || '上传失败'
    //     )
    //     return
    //   }
    //   this.$message({
    //     showClose: true,
    //     message: this.$l('INDEX.uploader_label_status_success') || '上传成功',
    //     type: 'success',
    //   })
    //   this.clearFiles()
    // },
    clearFiles() {
      this.$refs.uploader.clearFiles()
      this.listImageFile = []
      this.close()
    },
    reloadFiles() {
      this.$refs.uploader.clearFiles()
    },

    async uploadFabric() {
      if (!this.listImageFile || !this.listImageFile.length) {
        this.$message.warning(`请选择您需要上传的图片！`)
        return
      }
      this.loadingOpen()
      const listImage = await this.uploadFiles()
      const params = {
        resFabricScmCode: this.resFabricScmCode,
        resFabricRecordCode: this.resFabricRecordCode,
        fabricImageList: listImage,
      }
      const res = await this.$api
        .resFabricInfoPcPushImgApi(params)
        .catch(() => null)
      this.loadingClose()
      const { status } = res
      if (status !== 200) {
        this.$message.error(
          this.$l('INDEX.uploader_label_status_error') || '上传失败'
        )
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.uploader_label_status_success') || '上传成功',
        type: 'success',
      })
      this.$emit('closeImage')
      this.clearFiles()
    },
    /**
     * 上传图片
     * @return 上传成功后的图片信息
     */
    uploadFiles() {
      if (!this.listImageFile || !this.listImageFile.length) {
        return Promise.resolve([])
      }

      const uploadTask = this.listImageFile.map((file) => {
        return this.$api.SYS_UPLOAD(file.raw).then((res) => ({
          imageCode: res.body.fileId,
          imageUrl: res.body.url,
        }))
      })

      return Promise.all(uploadTask)
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame {
  padding: 1px 10px;
  border-left: 3px solid $color-primary;
}

.images-container {
  min-height: 500px;
}

.empty-image {
  display: flex;
  align-items: center;
  justify-content: center;
}

.image-box {
  width: 140px;
  height: 140px;
  line-height: 140px;
  position: relative;
  background-color: #fbfdff;
  border: 1px solid #c0ccda;
  border-radius: 6px;
  margin: 8px;
  position: relative;
  .default-icon {
    position: absolute;
    z-index: 999;
    right: 0;
    display: flex;
    align-items: flex-start;
    color: #20c997;
  }
}
.image-box:hover {
  .shadow {
    background-color: rgba(0, 0, 0, 0.5);
    opacity: 1;
  }
}

.shadow {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  right: 0;
  bottom: 0;
  top: 0;
  left: 0;
  border-radius: 6px;
  opacity: 0;
  transition: opacity 0.3s;
  color: #fff;
  font-size: 20px;
  line-height: 20px;
  padding: 2px;
}
</style>
